import type { TimeEntry } from '@nextinq/domain';

export function timeEntryFormatter(entry: TimeEntry): string {
  return `${entry.from} - ${entry.to}`;
}

export function openHoursFormatter(entries: Array<TimeEntry>): Array<string> {
  return entries.map(timeEntryFormatter);
}
